import React from 'react';
import NotFoundContent from '../componentes/NotFound/content';
const NotFound = () => {
    return (
        <NotFoundContent/>
    );
}
 
export default NotFound;